import { FC, ReactNode } from 'react';

export type PageContainerProps = {
  children: ReactNode;
  width?: 'standard' | 'wide';
  className?: string;
};

/** The page shell: centred, padded and capped to a reading or dashboard width. */
const PageContainer: FC<PageContainerProps> = ({ children, width = 'standard', className }) => (
  <div className={['ui-page-container', 'ui-page-container--' + width, className].filter(Boolean).join(' ')}>{children}</div>
);

export default PageContainer;
